import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import { clearChunkReloadGuard, reloadForChunkError } from "@/lib/chunkRecovery";

type Loader<T extends ComponentType<unknown>> = () => Promise<{ default: T }>;

export function lazyWithRetry<T extends ComponentType<unknown>>(loader: Loader<T>): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      const mod = await loader();
      clearChunkReloadGuard();
      return mod;
    } catch (error) {
      if (reloadForChunkError(error)) {
        await new Promise<never>(() => {
          // Wait forever because page reload is in progress.
        });
      }
      throw error;
    }
  });
}
